import { render, staticRenderFns } from "./VenueDetailInfo.vue?vue&type=template&id=07dffd3c&scoped=true"
import script from "./VenueDetailInfo.vue?vue&type=script&lang=ts"
export * from "./VenueDetailInfo.vue?vue&type=script&lang=ts"
import style0 from "./VenueDetailInfo.vue?vue&type=style&index=0&id=07dffd3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dffd3c",
  null
  
)

export default component.exports